import request from '@/utils/request'

// 历史浏览记录
export function drugHistory(data) {
  return request({
    url: 'drug/historyList',
    method: 'post',
    data
  })
}